import React from "react";

const MainDetailsTooltip = (props: any) => {
  const { value } = props;

  return (
    <div
      className="bg-gray-300 p-2 shadow-lg dark:bg-[#171717]"
      //   style={{ background: "white", padding: "6px", border: "1px solid #ccc" }}
    >
      <div>
        {value.split("|").map((leg: string, index: number) => {
          return (
            <div className="py-1" key={index}>
              - {leg}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MainDetailsTooltip;
